import { v4 } from 'uuid';

import type { SavedCashSpot } from '@/domain/WorkspaceForex/savedProducts/cash/SavedCashSpot.ts';
import type { FxCashSpot } from '@/store/cash/state.ts';

export const mapToFxCashSpot = ({ properties, clientId }: SavedCashSpot): FxCashSpot => {
  const [currency1, currency2] = properties.currencyPair?.split('/') ?? [undefined, undefined];

  return {
    type: 'FxSpot',
    clientId,
    properties: {
      currencyPair: properties.currencyPair,
      currency1,
      currency2,
      maturityDate: undefined,
      maturityDateTenor: 'SP',
      notional: properties.notional,
      notionalCurrencyIndex: properties.notionalCurrencyIndex ?? 1, // default to 1 to fix issue during the migration
    },

    tradeCapture: {
      status: 'INITIALIZED',
      sessionId: v4(),
      version: -1,
    },
  };
};
